import React from 'react';
import Grid from '@techsoftware/happay-widgets/Grid';
import {
  currencyFormatter,
  formatDate,
} from '@techsoftware/happay-widgets/CommonFunction/commonFunction';
import FileUpload from '@techsoftware/happay-widgets/FileUpload';
import ScheduleDatePicker from '../Invoice/ReschedulePayment/rescheduleDatepicker';
import LinkFormatter from '../customComponent/customTable/tableFormat/linkFormatter';

export default function ContainerView({
  cardIndex,
  cardTitle,
  cardContent,
  type,
  data,
  mappedValues = [],
  className,
  border,
  onChange,
}) {
  return (
    <Grid
      container
      className={`border-container-imp white-bg border-radius-4 ${className}`}
    >
      <Grid item className="payment-card-title border-b">
        <div
          className={`d-flex padding-lr-30 padding-tb-20 ${
            type === 'secondary' ? 'tertiary-color-bg' : ''
          }`}
        >
          <span className="rounded-indexing margin-r-10">{cardIndex}</span>{' '}
          <div className="fw-500 vendor-card-title">{cardTitle}</div>
        </div>
      </Grid>
      <Grid item>
        {type === 'secondary' ? (
          <Grid container className="padding-30" alignItems="flex-start">
            <MappedValues
              data={data}
              mappedValues={mappedValues}
              onChange={onChange}
              border={border}
              cardTitle={cardTitle}
            />
          </Grid>
        ) : (
          cardContent
        )}
      </Grid>
    </Grid>
  );
}

function MappedValues({
  data,
  mappedValues = [],
  border,
  onChange,
  cardTitle,
}) {
  const returnValue = el => {
    switch (el.type) {
      case 'date':
        return (
          <div>
            {formatDate(data[el.key], 'DD MMM, YYYY')}
            {cardTitle === 'Payment Details' ? (
              <span>{formatDate(data[el.key], ', h:mm A')}</span>
            ) : (
              ''
            )}
          </div>
        );
      case 'amount':
        return currencyFormatter(data[el.key], data.currency);
      case 'mobile_number':
        return `${data[el.extension_key] || ''} ${data[el.key]}`;
      case 'file':
        const file = {
          oldFiles:
            typeof data[el.key] === 'string' && data[el.key].length > 0
              ? [data[el.key]]
              : data[el.key] || [],
          newFiles: [],
          deletedFiles: [],
        };
        return (
          <FileUpload
            id="invoice-detail"
            files={file}
            multiple
            enableLightBox
            variant="tertiary"
            controllers={['fullscreen']}
            maxAttachment={5}
            inplaceUploadWrapper={{ height: '100px' }}
            mode="view"
            disabledInput={!file.oldFiles.length}
          />
        );
      case 'link': {
        return (
          <LinkFormatter
            className="font-14"
            data={data[el.key]}
            createdBy={data.created_by}
            containerType={data.container_type}
            id={data[el.id]}
          />
        );
      }
      default:
        return el.staticText ? el.staticText : data[el.key] || '---';
    }
  };

  const getBorder = (border = 'left', index) => {
    if (border === 'right' && index % 2 !== 1) {
      return border;
    }
    if (border === 'left' && index % 2 === 1) {
      return border;
    }
  };

  return mappedValues.map(
    (el, i) =>
      el && (
        <Grid
          item
          xs={24}
          sm={24}
          md={el.type === 'file' ? 24 : 12}
          xl={el.type === 'file' ? 24 : 12}
          lg={el.type === 'file' ? 24 : 12}
          className={`padding-b-24 padding-lr-30 ${
            el.hideBorder ? '' : `border-${getBorder(border, i)}`
          }`}
        >
          {!el.edit ? (
            <>
              <div className="font-12 body">{el.text}</div>
              <div className="body dark margin-t-6">{returnValue(el)}</div>
            </>
          ) : (
            <ScheduleDatePicker
              id="invoice-schedule-date"
              date={formatDate(data[el.key], 'DD MMM, YYYY')}
              onChange={onChange}
              error={el.error}
            />
          )}
        </Grid>
      ),
  );
}
